import { format } from 'date-fns';
import React from 'react';
import { Button, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import EditIcon from '../../Res/Icon/edit.png';
import ViewIcon from '../../Res/Icon/view.png';
import LogImg from '../../Res/Icon/logImg.png';
import DeleteIcon from '../../Res/Icon/delete.png';
import NumberRoute from './NumberRoute';
import utils from '../../lib/utils';

const AllNumber = ({ number, onEdit, user, selectRoute, gateways, onDelete, onShowLog }) => {
  const { type, company, _id, routeInfo } = number;
  const changeNumberRoute = (e) => {
    let obj = {}
    if (number.carrier == 'inteliquent') {
      obj.trunk = e.currentTarget.value
    }
    if (number.carrier == 'voicetel') {
      obj.routeInfo = {
        route: JSON.parse(e.currentTarget.value).route,
        gateway: JSON.parse(e.currentTarget.value).gateway,
      }
    }
    if (number.carrier == 'tdm') {
      obj.tdmRoute = e.currentTarget.value
    }
    selectRoute(_id, obj);
  }
  return (
    <tr>
      <td>{number.number}</td>
      <td>
        {number?.linkedBox?._id ? (
          <Link
            className="box-name-link"
            to={`/boxes/${number?.linkedBox?._id}?company=${number?.linkedBox?.assignedTo}`}
          >
            {number?.linkedBox?.displayName}
          </Link>
        ) : (
          '-'
        )}
      </td>
      <td>{number.temporary}</td>
      <td>{company && company.name}</td>
      {
        utils.filterCustomer(user?.role) ? (
          <td>{number.carrier === 'voicetel' ? 'VT' : number.carrier === 'tdm' ? "TDM" : 'IQ'}</td>
        ) : null
      }

      <td>{type}</td>

      {user.role === 'superAdmin' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'supportEngineer' ? (
        <td style={{ width: '20%' }}>
          <NumberRoute
            onChange={changeNumberRoute}
            number={number}
          />
        </td>
      ) : null}
      <td>
        {(number.dateCreated && utils.getDateTimeFormat(number.dateCreated, 'regular')) || ''}
      </td>
      {

        utils.filterCustomer(user?.role) ? (

          user.role === 'superAdmin' ||
            user.role === 'companyGroupAdmin' ||
            user.role === 'supportEngineer' ? (
            <>
              {number.linkedBox ? <td></td> : (
                <td>
                  <Button
                    style={{ background: 'inherit', border: 'none' }}
                    onClick={() => {
                      onDelete({
                        ...number,
                      });
                    }}
                  >
                    <img style={{ height: '22px' }} src={DeleteIcon} alt="delete" />
                  </Button>
                </td>
              )}
              <td>
                <Button
                  style={{ background: 'inherit', border: 'none' }}
                  onClick={() => {
                    onShowLog(number._id)
                  }}
                >
                  <img style={{ height: '22px' }} src={LogImg} alt="showLog" />
                </Button>
              </td>
              <td>
                <Button
                  style={{ background: 'inherit', border: 'none' }}
                  onClick={() => {
                    onEdit({
                      ...number,
                    });
                  }}
                >
                  <img style={{ height: '22px' }} src={EditIcon} alt="edit" />
                </Button>
              </td>
            </>
          ) : (
            <td>
              <Button
                style={{ background: 'inherit', border: 'none' }}
                onClick={() => {
                  onEdit({
                    ...number,
                  });
                }}
              >
                <img style={{ height: '22px' }} src={ViewIcon} alt="view" />
              </Button>
            </td>
          )) : null}
    </tr>
  );
};

export default AllNumber;
